cb.define([], function() {
    var AA_aa_customerprolist_VM_Extend = {
        doAction: function(name, viewmodel) {
            if (this[name]) {
                this[name](viewmodel);
            }
        },
        init: function(viewmodel) {
            viewmodel.on('beforeBatchdelete', args => {
                let _data = viewmodel.get('aa_customerprolist').getRow(args.params.params.index)
                if (_data.sourcetype) {
                    cb.utils.alert('系统预制的属性不能删除', 'warning');
                    return false
                }
            })
        },
    }
    try {
        module.exports = AA_aa_customerprolist_VM_Extend;
    } catch (error) {
        // 当 类型 为 档案 的时候
    }
    return AA_aa_customerprolist_VM_Extend;
});


// WEBPACK FOOTER //
// ./src/client/business/AA/AA_aa_customerprolist_VM.Extend.js